module.exports = __webpack_public_path__ + "static/cloud2-684e488e9cd47552f6145cf67935e6fa.webp";